// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"45c573a1","453":"097dc447","952":"9ca3fbf5"}[chunkId] + ".chunk.js";
};